import { render, staticRenderFns } from "./CardsPeriodIndexSelect.vue?vue&type=template&id=16515a36&scoped=true"
import script from "./CardsPeriodIndexSelect.vue?vue&type=script&lang=js"
export * from "./CardsPeriodIndexSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16515a36",
  null
  
)

export default component.exports